<template>
  <el-container class="app-wrapper">
    <side-bar />
    <el-container class="main-container">
      <nav-bar />
      <app-main />
    </el-container>
  </el-container>
</template>

<script>
import NavBar from './components/nav-bar.vue'
import SideBar from './components/side-bar.vue'
import AppMain from './components/app-main.vue'

export default {
  name: 'Layout',
  components: {
    NavBar,
    SideBar,
    AppMain
  }
}
</script>

<style>
.app-wrapper {
  position: relative;
  height: 100vh;
  width: 100%;
}

.main-container {
  flex-direction: column;
  min-height: 100%;
  transition: margin-left 0.28s;
  margin-left: 200px;
  background-color: #f0f2f5;
}
</style>
